var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: ["usage-type-emblem", _vm.type, { "no-text": !_vm.text }] },
    [
      _c(
        "div",
        { staticClass: "usage-type-emblem-icon" },
        [_c(_setup.Icon, { attrs: { icon: _setup.icon } })],
        1
      ),
      _vm._v(" "),
      _vm.text
        ? _c("div", { staticClass: "usage-type-emblem-label" }, [
            _vm._v("\n    " + _vm._s(_setup.label) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }